var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"LaVimeoPlayer"},[_c('iframe',{ref:"laVimeoPlayerFrame",staticClass:"card border-0",attrs:{"id":"laVimeoPlayerFrame","src":`https://player.vimeo.com/video/${_vm.videoId}`,"width":"100%","height":"400","allow":"autoplay; fullscreen","allowfullscreen":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }